module.exports = __webpack_public_path__ + "static/media/logo-14.97c2b38b.svg";